import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { withRouter } from 'react-router-dom';
import { reduxForm, formPropTypes, SubmissionError } from 'redux-form';
import { Button, ButtonToolbar } from 'react-bootstrap';

import PasswordResetRequestFormSection, { validate } from './PasswordResetRequestFormSection';
import { requestPasswordReset } from '../../actions';
import { isAxiosResponseError } from '../../../../utils/errorTypeCheck';
import { routerProps } from '../../../../propTypes';

const propTypes = exact({
  ...formPropTypes,
  ...routerProps,
  validate: PropTypes.func.isRequired,
});


const PasswordResetRequestForm = (props) => {
  const {
    handleSubmit,
    pristine,
    submitting,
    error,
    requestPasswordResetAction,
    invalid,
  } = props;

  const onSubmit = async (values) => {
    try {
      await requestPasswordResetAction(values.email);

      const { history } = props;
      history.push('./?state=success');
    } catch (e) {
      if (isAxiosResponseError(e)) {
        throw new SubmissionError({ _error: e.message });
      } else {
        throw e;
      }
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <PasswordResetRequestFormSection />

      <ButtonToolbar className="pull-right">
        <Button
          bsStyle="primary"
          disabled={submitting || pristine || invalid}
          type="submit"
        >Submit
        </Button>
      </ButtonToolbar>
      {error
      && <span>{error}</span>}
    </form>
  );
};

const withForm = reduxForm({
  form: 'passwordResetRequestForm',
  validate,
  enableReinitialize: true,
});


const mapDispatchToProps = {
  requestPasswordResetAction: requestPasswordReset,
};

const withRedux = connect(null, mapDispatchToProps);

const enhance = compose(
  withRedux,
  withForm,
  withRouter,
);

PasswordResetRequestForm.propTypes = propTypes;


export default enhance(PasswordResetRequestForm);
